import { Thunk } from 'state/state.common';
import {
  underlyingsBlackoutDatesRequested,
  underlyingsSpecificDatesRequested,
} from 'state/underlyingsDates/underlyingsDates.action';
import { WorkspaceType } from 'state/workspaces/model';

export function formUnderlyingsDatesRequestedThunk(
  tabId: string,
  onlySpecificDates: boolean,
  workspace: WorkspaceType,
): Thunk<void> {
  return (
    dispatch,
    getState,
    {
      selectors: {
        underlyingsDatesSelector: { buildUnderlyingsDatesPayload, isUnderlyingsDatesExists },
      },
    },
  ) => {
    const state = getState();
    const underlyingsDatesPayload = buildUnderlyingsDatesPayload(state, tabId, workspace);
    if (underlyingsDatesPayload === undefined || isUnderlyingsDatesExists(state, underlyingsDatesPayload)) {
      return;
    }
    if (onlySpecificDates) {
      dispatch(underlyingsSpecificDatesRequested(underlyingsDatesPayload));
    } else {
      dispatch(underlyingsBlackoutDatesRequested(underlyingsDatesPayload));
    }
  };
}
